import ActionTypes, { CertificateType, EntityType, TCerteficateState } from './types';
import { Actions, TDefRequest } from '../Action';
import { action } from 'typesafe-actions';

export const setCerteficate = (payload: CertificateType) => action(ActionTypes.SET_CERTEFICATE, payload);

const GetCerteficateAction = new Actions('GET_CERTEFICATE', ActionTypes);
export interface TypeGetCerteficateR extends TDefRequest {
  data: {
    event_id: number;
  };
}
export const GetCerteficate = {
  request: (payload: TypeGetCerteficateR) => GetCerteficateAction.request(payload),
  success: (payload: TCerteficateState['data']) => GetCerteficateAction.success(payload || {}),
  error: (message: string) => GetCerteficateAction.error(message),
};

const UpdateCerteficateAction = new Actions('UPDATE_CERTEFICATE', ActionTypes);
export interface TypeUpdateCerteficateR extends TDefRequest {
  data: {
    event_id: number;
    fio_ua: string;
  };
}
export const UpdateCerteficate = {
  request: (payload: TypeUpdateCerteficateR) => UpdateCerteficateAction.request(payload),
  success: (payload: EntityType) => UpdateCerteficateAction.success(payload || {}),
  error: (message: string) => UpdateCerteficateAction.error(message),
};

const UpdateCerteficateProfileAction = new Actions('UPDATE_CERTEFICATE_PROFILE', ActionTypes);
export interface TypeUpdateCerteficateProfileR extends TDefRequest {
  data: {
    event_id: number;
    workPlace: string;
    email: string;
    phone: string;
    education: string;
    position: string;
    dateBirth: string;
  };
}
export const UpdateCerteficateProfile = {
  request: (payload: TypeUpdateCerteficateProfileR) => UpdateCerteficateProfileAction.request(payload),
  success: (payload: CertificateType) => UpdateCerteficateProfileAction.success(payload || {}),
  error: (message: string) => UpdateCerteficateProfileAction.error(message),
};
